<template>
  <div class="dropdown">
    <div @click="close" class="dropdown-mask"></div>
    <div class="dropdown-container">
      <div
        v-for="(row, i) in data" :key="i"
        @click="click(row, i)"
        class="dropdown-item" :class="index === i ? 'dropdown-item-active' : 'dropdown-item-default'"
      >
        <div class="dropdown-item-text">{{row.label}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    index: {
      type: Number,
      default: -1
    }
  },
  methods: {
    close () { this.$emit('close') },
    click (row, i) {
      this.$emit('click', row, i)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.dropdown {
  height: 106px;
  border: 1px solid var(--colorGray3);
  overflow-y: auto;
  & .dropdown-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
  }
  & .dropdown-container {
    z-index: 1;
    position: relative;
    padding: 10px;
    & .dropdown-item {
      min-height: 30px;
      cursor: pointer;  
      @media (--mediaPc) {
        border-radius: var(--borderRadius1);
      }
      @media (--mediaMobile) {
        border-radius: var(--borderRadius1Mobile);
      }
      &.dropdown-item-default {
      }
      &.dropdown-item-active {
        background-color: var(--colorGray3);
      }

      & .dropdown-item-text {
        padding: 8px 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dropdown/BaseDropdown.vue